/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseFunctionCallArgumentsDeltaEvent = {
  type: "response.function_call_arguments.delta";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  delta: string;
};

/** @internal */
export const ResponseFunctionCallArgumentsDeltaEvent$inboundSchema: z.ZodType<
  ResponseFunctionCallArgumentsDeltaEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.function_call_arguments.delta"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  delta: z.string(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseFunctionCallArgumentsDeltaEvent$Outbound = {
  type: "response.function_call_arguments.delta";
  sequence_number: number;
  item_id: string;
  output_index: number;
  delta: string;
};

/** @internal */
export const ResponseFunctionCallArgumentsDeltaEvent$outboundSchema: z.ZodType<
  ResponseFunctionCallArgumentsDeltaEvent$Outbound,
  z.ZodTypeDef,
  ResponseFunctionCallArgumentsDeltaEvent
> = z.object({
  type: z.literal("response.function_call_arguments.delta"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  delta: z.string(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseFunctionCallArgumentsDeltaEventToJSON(
  responseFunctionCallArgumentsDeltaEvent:
    ResponseFunctionCallArgumentsDeltaEvent,
): string {
  return JSON.stringify(
    ResponseFunctionCallArgumentsDeltaEvent$outboundSchema.parse(
      responseFunctionCallArgumentsDeltaEvent,
    ),
  );
}
export function responseFunctionCallArgumentsDeltaEventFromJSON(
  jsonString: string,
): SafeParseResult<
  ResponseFunctionCallArgumentsDeltaEvent,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseFunctionCallArgumentsDeltaEvent$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ResponseFunctionCallArgumentsDeltaEvent' from JSON`,
  );
}
